module.exports = __webpack_public_path__ + "static/img/logo_changtong.57847ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_changtong.png
// module id = 1t5f
// module chunks = 51